import TextField from '@material-ui/core/TextField';
import React from 'react';

const FormTextField = ({
  input,
  label,
  submissionError,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    inputRef={custom.setInputRef}
    type={custom.type}
    hinttext={label}
    label={label}
    error={!!(submissionError || (touched && error))}
    helperText={submissionError || (touched && error)}
    {...input}
    {...custom}
  />
);

export default FormTextField;



// WEBPACK FOOTER //
// ./src/components/FormElements/FormTextField.jsx